
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpCarrierShippingAccountList
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpCarrierShippingAccountList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierShipping/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: this.handleAuth('fbb.shipping.edit'),
                params: id,
                operate: 'edit'
            }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAll",
            "getBillcusWareList",
        ]),
        // ...mapGetters('diction', ['getNewProductList', 'getAllCurrency', 'getAllSupplier', 'getNewDifferentAllProductList']),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    show: this.handleAuth('fbb.shipping.add'),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.shipping.export'),
                    theme: 'success'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_warehouseId',
                    show: true,
                    tag: 'Select',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierCode',
                    options: this.getCarrierAll,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: 'Shipping账号' }),
                    tag: 'Input',
                    show: true,
                    key: 'EQ_carrierAccount',
                    style: widthStyle
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    render: (h, { row }) => {
                        let warehouseItem = this.getBillcusWareList.filter(item => {
                            return item.value === row.warehouseId
                        })[0];
                        return <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    render: (h, { row }) => {
                        let carrierItem = this.getCarrierAll.filter(item => {
                            return item.value === row.carrierCode
                        })[0];
                        return (
                            <div>{carrierItem ? carrierItem.label : '--'}</div>
                        )
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: 'Shipping账号' }),
                    key: 'carrierAccount'
                },
                {
                    title: 'Update Time',
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
